import Offcanvas from "bootstrap/js/dist/offcanvas";
import offcanvasController from "./controller.js";

export default offcanvasController(Offcanvas);
